var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"ods-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"ods-dropdown-menu ods-popper",class:[_vm.size && `ods-dropdown-menu--${_vm.size}`]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }